import React, { useRef, useState } from "react";
import CustomDiv from "../CustomDiv";
import SignIn from "../../Authentication/SignInPage";
import TemporaryDrawer from "./AddToCart";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { myWishList } from "../../Services/WishList";
import { API_URLS } from "../../Config/API_URLS";
import axiosInstance from "../../Config/axios";
import { useEffect } from "react";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";

import {
  Autocomplete,
  Badge,
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  MenuTwoTone,
  ArrowDropDownOutlined,
  Search,
} from "@mui/icons-material";
import { categoryListFn } from "../../Services/CategoryList";
import { useDispatch } from "react-redux";
import { setThemeMode } from "../../Redux/Actions/ThemeMode";
import classNames from "classnames";

const Headers = () => {
  const [open, setOpen] = useState(false);
  const [collapse, setCollapse] = useState([]);
  const [spices, setSpices] = React.useState([]);
  const [search, setSearch] = useState(false);
  const [header, setHeader] = useState([]);
  const [serchProduct, setSerchProduct] = useState([]);
  const [serch, setSerch] = useState("");
  const listEndRef = useRef(null);
  const [activeItem, setActiveItem] = useState(0);
  const [menu, setMenu] = useState(false);

  const [productId, setProductId] = useState({});

  const CustomizationHeader = () => {
    axiosInstance
      .get(API_URLS.HeaderCustomization)
      .then((response) => {
        setHeader(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    CustomizationHeader();
  }, []);

  const SerchData = () => {
    const reqbody = new FormData();
    reqbody.append("search", serch);
    axiosInstance
      .post(API_URLS.Serch, reqbody)
      .then((response) => {
        setSerchProduct(response?.data?.data?.product_list);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(
    () => {
      serch && SerchData();
    },
    // eslint-disable-next-line
    [serch]
  );

  const products = spices?.map((product) => {
    return {
      image: product.image,
      variant: product.variant_name,
      sub_category: product.sub_category,
      id: product.id,
      vid: product?.variant_id,
    };
  });

  const handleClick = (id) => {
    setCollapse((collapse) => [...collapse, id]);
  };
  const handleClose = (id) => {
    setCollapse(collapse?.filter((item) => item !== id));
  };
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { data } = useQuery(["wishList"], () => myWishList());

  const { data: mainCategoryList } = useQuery(
    ["mainCategoryList"],
    () => categoryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const handleChange = (event) => {
    navigate(`/product/${event.currentTarget.lastChild.innerHTML}`);
    sessionStorage.clear();
    setOpen(false);
  };

  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };
  const handleKeyDown = (event, option) => {
    const { key } = event;

    if (key === "Enter") {
      navigate(`/product/${productId?.id}/${productId?.vid}`);

      console.log("productID", option);
    }
    // navigate(`/product/${option?.id}/${option?.vid}`);
  };
  const handleListItemKeyDown = (event, listId) => {
    const { key } = event;
    document
      .getElementById(serchProduct?.[activeItem]?.variant_id)
      ?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    if (key === "ArrowDown") {
      activeItem !== serchProduct?.length - 1 &&
        setActiveItem((prevIndex) => prevIndex + 1);
    } else if (key === "ArrowUp") {
      activeItem !== 0 && setActiveItem((prevIndex) => prevIndex - 1);
    } else if (key === "Enter") {
      serchProduct?.[activeItem]?.id &&
        serchProduct?.[activeItem]?.variant_id &&
        navigate(
          `/product/${serchProduct?.[activeItem]?.id}/${serchProduct?.[activeItem]?.variant_id}`
        );

      setSerch("");
    }
  };
  const handleLooseFocus = () => {
    setTimeout(() => {
      setMenu(false);
    }, 500);
    return clearTimeout;
  };

  console.log(header, "header");

  return (
    <CustomDiv className="lg:h-0 h-[25px] sticky z-50 shadow">
      <CustomDiv className="flex flex-col border-b-2  justify-between items-center fixed z-50  bg-white bg-opacity- text-black backdrop-blur w-full px-[4%] lg:px-[4%]">
        <CustomDiv className="flex items-center justify-between py-4 w-full">
          <span className="flex items-center gap-5">
            {/* <img
              src={brandLogo}
              alt=""
              className="relative h-20 cursor-pointer"
              onClick={() => navigate("/")}
            /> */}
            <p
              onClick={() => navigate("/")}
              className="lg:text-3xl text-sm font-bold cursor-pointer whitespace-nowrap gap-3"
              style={{ fontVariant: "small-caps" }}
            >
              Fusion Vastras
            </p>
          </span>

          <span className="bg-white py-2 outline-none !border rounded-md border-gray-500 dropdown  lg:flex justify-between hidden items-center">
            <span className="pl-3">
              <Search className="text-gray-400" />
            </span>
            <input
              className="!w-[400px] outline-none bg-transparent px-4"
              type="text"
              value={serch}
              placeholder="Search for Products"
              onChange={(e) => {
                setSerch(e.target.value);
                setSerchProduct([]);
              }}
            />

            {serch && (
              <List className="!absolute !hidden lg:!block !h-fit top-0 !shadow-md border z-50 rounded !p-0">
                <span
                  onKeyDown={(event) => handleListItemKeyDown(event, 1)}
                  className={classNames(
                    "bg-white lg:flex outline-none hidden shadow dropdown border-stone-50 px-3 py-2 justify-between items-center"
                  )}
                >
                  <input
                    className={classNames(
                      "!w-[388px] outline-none bg-transparent px-3"
                    )}
                    autoFocus
                    value={serch}
                    type="text"
                    placeholder="Search for Products, Brands, Offers"
                    onBlur={() => {
                      setTimeout(() => {
                        setSerch("");
                        setSerchProduct([]);
                      }, 500);
                    }}
                    onChange={(e) => {
                      setSerch(e.target.value);
                      setSerchProduct([]);
                    }}
                  />
                  <Search />
                </span>

                <div className="overflow-y-auto pt-px bg-white !max-h-[390px]">
                  {true ? (
                    serchProduct?.map((item, index) => {
                      return (
                        <>
                          <ListItemButton
                            ref={listEndRef}
                            id={item.variant_id}
                            onClick={() => {
                              navigate(
                                `/product/${item.id}/${item.variant_id}`
                              );
                            }}
                            className={classNames(
                              activeItem === index &&
                                "bg-gradient-to-t from-green-50 !text-black to-green-300"
                            )}
                            selected={activeItem === index}
                          >
                            <ListItemIcon>
                              <img
                                src={item.variant_image || item.image}
                                alt=""
                                className="h-12 rounded"
                              />
                            </ListItemIcon>
                            <span className="flex flex-col">
                              <span>{item.variant_name}</span>
                              <span>{item.brand_name}</span>
                            </span>
                          </ListItemButton>
                        </>
                      );
                    })
                  ) : (
                    <>
                      {[1, 2, 3, 4, 5, 6].map((item) => {
                        return (
                          <ListItemButton key={item} className="flex gap-5 p-2">
                            <Skeleton className="!scale-100 !h-12 !w-12" />
                            <span className="flex flex-col w-full">
                              <Skeleton className="w-4/5" />
                              <Skeleton className="w-1/2" />
                            </span>
                          </ListItemButton>
                        );
                      })}
                    </>
                  )}
                </div>
              </List>
            )}
          </span>
          <div className="lg:block hidden">
            <span className="flex  items-center gap-4 lg:gap-5">
              <span className=" flex flex-col items-center border-r-2 border-gray-400 px-5">
                <SignIn />
                <p className="font-bold">Profile</p>
              </span>

              <span className="flex flex-col items-center border-r-2 border-gray-400 px-5 cursor-pointer">
                <Badge
                  className="!bg-black"
                  badgeContent={
                    localStorage.getItem("token")
                      ? data?.data?.data?.wishlist_product_list?.length
                      : 0
                  }
                  color="primary"
                >
                  <img
                    alt=""
                    src={
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJoia48EP0RFCp6JuIODLjXJMfe0qE3m58yDQ2CiLsl_fKh9-VPfOKW21z7tefUiY8cRs&usqp=CAU"
                    }
                    className="cursor-pointer h-5"
                    onClick={() =>
                      localStorage.getItem("token")
                        ? navigate("/wish-list")
                        : handleLogin()
                    }
                  />
                </Badge>
                <p className="font-bold">Wishlist</p>
              </span>
              <span className="border-r-2 border-gray-400 px-5">
                <TemporaryDrawer />
                <p className="font-bold lg:block hidden">Cart</p>
              </span>

              <span
                onClick={() =>
                  localStorage.getItem("token")
                    ? navigate("/wallet")
                    : handleLogin()
                }
                className="flex flex-col items-center cursor-pointer px-5 "
              >
                <AccountBalanceWalletOutlinedIcon />

                <p className=" font-bold">Wallet</p>
              </span>

              <IconButton onClick={() => setOpen(true)}>
                <MenuTwoTone className="!block lg:!hidden !text-black" />
              </IconButton>
              <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
                <CustomDiv className="">
                  <List className="!pr-0">
                    <span className="!p-4 flex justify-center">
                      <Autocomplete
                        options={products || []}
                        autoHighlight
                        size="small"
                        className="Product"
                        freeSolo
                        sx={{ width: 260 }}
                        onChange={handleChange}
                        disableClearable
                        getOptionLabel={(option) => option?.variant}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                            onClick={() => {
                              navigate(`/product/${option?.id}/${option?.vid}`);
                              setSearch(false);
                            }}
                            onKeyDown={handleKeyDown(option)}
                          >
                            <img
                              loading="lazy"
                              width="50"
                              src={option.image}
                              srcSet={option?.image}
                              alt=""
                            />

                            <span className="flex flex-col">
                              <span className="text-lg">{option?.variant}</span>
                              <span className="text-sm">
                                {option?.sub_category}
                              </span>
                            </span>

                            <span id="variant_id" hidden>
                              {option?.id}
                            </span>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search Products"
                            inputProps={{
                              ...params?.inputProps,
                              autoComplete: "new-password", // disable autocomplete and autofill
                            }}
                          />
                        )}
                      />
                    </span>

                    <ListItemButton
                      onClick={() =>
                        navigate("/all-products", {
                          state: { from: "allproduct" },
                        })
                      }
                      className="!flex  !justify-between !w-full cursor-pointer"
                    >
                      All Products
                    </ListItemButton>
                    {mainCategoryList?.data?.data?.main_category_list?.map(
                      (product1) => {
                        return (
                          <>
                            <ListItemButton
                              onClick={() => {
                                return (
                                  <>
                                    {collapse.indexOf(product1?.id) === -1
                                      ? handleClick(product1?.id)
                                      : handleClose(product1?.id)}
                                  </>
                                );
                              }}
                              className="!flex !justify-between !w-full"
                            >
                              <span>{product1?.category}</span>

                              {collapse ? <ExpandMore /> : <ExpandLess />}
                            </ListItemButton>
                            <Collapse
                              in={collapse?.indexOf(product1?.id) !== -1}
                              className=""
                            >
                              <List>
                                {product1?.sub_category_list?.map(
                                  (subCategory) => {
                                    return (
                                      <ListItemButton
                                        className="!flex !pl-8 !justify-between !w-full"
                                        onClick={() =>
                                          navigate(`/all-products`, {
                                            state: {
                                              from: "subCategory",
                                              subCategory: subCategory?.id,
                                            },
                                          })
                                        }
                                      >
                                        {subCategory?.subcategory}
                                      </ListItemButton>
                                    );
                                  }
                                )}
                              </List>
                            </Collapse>
                          </>
                        );
                      }
                    )}
                  </List>
                </CustomDiv>
              </Drawer>
            </span>
          </div>
          <div className="lg:hidden">
            <span className="flex items-center gap-4 lg:gap-7">
              <SignIn />
              <Badge
                className="!bg-black"
                badgeContent={
                  localStorage.getItem("token")
                    ? data?.data?.data?.wishlist_product_list?.length
                    : 0
                }
                color="primary"
              >
                <img
                  alt=""
                  src={
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJoia48EP0RFCp6JuIODLjXJMfe0qE3m58yDQ2CiLsl_fKh9-VPfOKW21z7tefUiY8cRs&usqp=CAU"
                  }
                  className="cursor-pointer h-7"
                  onClick={() =>
                    localStorage.getItem("token")
                      ? navigate("/wish-list")
                      : handleLogin()
                  }
                />
              </Badge>

              <TemporaryDrawer />

              <Badge className="!bg-black" color="primary">
                <img
                  alt=""
                  src="https://www.shutterstock.com/image-vector/wallet-icon-vector-260nw-1377533453.jpg"
                  className="h-11 cursor-pointer"
                  onClick={() =>
                    localStorage.getItem("token")
                      ? navigate("/wallet")
                      : handleLogin()
                  }
                />
              </Badge>

              <IconButton onClick={() => setOpen(true)}>
                <MenuTwoTone className="!block lg:!hidden !text-black" />
              </IconButton>
              <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
                <CustomDiv className="">
                  <List className="!pr-0">
                    <span className="!p-4 flex justify-center">
                      <Autocomplete
                        options={products || []}
                        autoHighlight
                        size="small"
                        className="Product"
                        freeSolo
                        sx={{ width: 260 }}
                        onChange={handleChange}
                        disableClearable
                        getOptionLabel={(option) => option?.variant}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                            onClick={() => {
                              navigate(`/product/${option?.id}/${option?.vid}`);
                              setSearch(false);
                            }}
                            onKeyDown={handleKeyDown(option)}
                          >
                            <img
                              loading="lazy"
                              width="50"
                              src={option.image}
                              srcSet={option?.image}
                              alt=""
                            />

                            <span className="flex flex-col">
                              <span className="text-lg">{option?.variant}</span>
                              <span className="text-sm">
                                {option?.sub_category}
                              </span>
                            </span>

                            <span id="variant_id" hidden>
                              {option?.id}
                            </span>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search Products"
                            inputProps={{
                              ...params?.inputProps,
                              autoComplete: "new-password", // disable autocomplete and autofill
                            }}
                          />
                        )}
                      />
                    </span>

                    <ListItemButton
                      onClick={() =>
                        navigate("/all-products", {
                          state: { from: "allproduct" },
                        })
                      }
                      className="!flex  !justify-between !w-full cursor-pointer"
                    >
                      All Products
                    </ListItemButton>
                    {mainCategoryList?.data?.data?.main_category_list?.map(
                      (product1) => {
                        return (
                          <>
                            <ListItemButton
                              onClick={() => {
                                return (
                                  <>
                                    {collapse.indexOf(product1?.id) === -1
                                      ? handleClick(product1?.id)
                                      : handleClose(product1?.id)}
                                  </>
                                );
                              }}
                              className="!flex !justify-between !w-full"
                            >
                              <span>{product1?.category}</span>

                              {collapse ? <ExpandMore /> : <ExpandLess />}
                            </ListItemButton>
                            <Collapse
                              in={collapse?.indexOf(product1?.id) !== -1}
                              className=""
                            >
                              <List>
                                {product1?.sub_category_list?.map(
                                  (subCategory) => {
                                    return (
                                      <ListItemButton
                                        className="!flex !pl-8 !justify-between !w-full"
                                        onClick={() =>
                                          navigate(`/all-products`, {
                                            state: {
                                              from: "subCategory",
                                              subCategory: subCategory?.id,
                                            },
                                          })
                                        }
                                      >
                                        {subCategory?.subcategory}
                                      </ListItemButton>
                                    );
                                  }
                                )}
                              </List>
                            </Collapse>
                          </>
                        );
                      }
                    )}
                  </List>
                </CustomDiv>
              </Drawer>
            </span>
          </div>
        </CustomDiv>
      </CustomDiv>
      <CustomDiv className="hidden  border-b-2 pl-10 justify-center  sticky top-0 z-20 lg:flex gap-10  lg:py-6 px-2 mb-1 bg-white shadow  items-center lg:pt-[95px]">
        <div
          onClick={() =>
            navigate("/all-products", {
              state: { from: "allproduct" },
            })
          }
          className="flex flex-col justify-center items-center gap-2"
        >
          <p className=" font-bold text-gray-800 cursor-pointer mt-3">
            All Products
          </p>
        </div>
        {header?.map((item, index) => {
          return (
            <div className="group inline-block relative">
              <Typography className="flex flex-col justify-center items-center gap-2">
                <p
                  className=" flex items-center font-bold mt-3 hover:text-gray-800 cursor-pointer"
                  onMouseEnter={() => setMenu(true)}
                  onClick={() =>
                    navigate(item.url, {
                      state: {
                        from: "category",
                        title: item.title,
                        category_id: item.id,
                      },
                    })
                  }
                >
                  {item?.title}
                  <ArrowDropDownOutlined />
                </p>
              </Typography>
              <ul
                className={classNames(
                  "absolute hidden justify-between w-[600px] p-2 z-50 shadow bg-[#FAFAFA] bg-opacity-80 backdrop-blur text-black border-t-4 border-[#6F5E18] rounded-sm group-hover:grid group-hover:grid-cols-2",
                  (index === header?.length - 1 ||
                    index === header?.length - 2 ||
                    index === header?.length - 3) &&
                    "right-0"
                )}
              >
                <span className="grid  grid-cols-2">
                  {item?.customization_header &&
                    item?.customization_header?.map((subHeader) => {
                      return (
                        <li
                          key={subHeader.id}
                          className="p-2  flex flex-col gap-2"
                          onClick={() => {
                            navigate(subHeader?.url, {
                              state: {
                                from: "subHeader",
                                title: subHeader?.title,
                                sub_category_id: subHeader?.id,
                              },
                            });
                            handleLooseFocus();
                          }}
                        >
                          <span className="cursor-pointer hover:underline     text-gray-700 text-md flex gap-x-2">
                            {subHeader?.title}{" "}
                            <span className="text-gray-500 text-sm mt-1">
                              ►
                            </span>
                          </span>

                          <ui className=" text-start grid col-span-3 px-0">
                            {subHeader?.sub_customization_header &&
                              subHeader?.sub_customization_header?.map(
                                (row) => {
                                  return (
                                    <li
                                      key={row.id}
                                      className="py-1 flex flex-col text-sm gap-2 cursor-pointer hover:underline"
                                      onClick={() => {
                                        navigate(row?.url, {
                                          state: {
                                            from: "subHeader",
                                            title: row?.title,
                                            sub_category_id: row?.id,
                                          },
                                        });
                                        handleLooseFocus();
                                      }}
                                    >
                                      {row?.title}
                                    </li>
                                  );
                                }
                              )}
                          </ui>
                        </li>
                      );
                    })}
                </span>
                <img
                  src={item?.image}
                  alt="s"
                  className="!w-72 !h-96 !items-end !float-right"
                />
              </ul>
            </div>
          );
        })}

        {/* {mainCategoryList?.data?.data?.main_category_list
          ?.slice(0, 6)
          ?.map((product) => {
            return (
              <div className="group inline-block relative">
                <Typography className="flex flex-col justify-center items-center gap-2">
                  <p
                    className="text-sm flex items-center font-bold text-gray-800 cursor-pointer"
                    onMouseEnter={() => setMenu(true)}
                  >
                    {product?.category}
                  </p>
                </Typography>
                <ul
                  className={classNames(
                    "absolute   hidden w-96 p-2 z-50 shadow bg-white bg-opacity-80 backdrop-blur text-black border-t-4 group-hover:grid-cols-4 border-[#306BDE] rounded-sm ",
                    menu && "group-hover:grid"
                  )}
                >
                  {product?.sub_category_list?.map((subCategory) => {
                    return (
                      <li
                        key={subCategory.id}
                        className="p-2 flex flex-col gap-2 cursor-pointer hover:underline"
                        onClick={() => {
                          navigate(`/all-products`, {
                            state: {
                              from: "subCategory",
                              subCategory: subCategory?.id,
                            },
                          });
                          handleLooseFocus();
                        }}
                      >
                        {subCategory?.subcategory}
                      </li>
                    );
                  })}
                  <img src={product?.image} alt="s" className="w-full" />
                </ul>
              </div>
            );
          })} */}
      </CustomDiv>
    </CustomDiv>
  );
};

export default Headers;
